// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Skeleton } from '@/components/ui/Skeleton';

export function BoardSkeleton() {
  return (
    <div className="max-w-5xl space-y-4">
      <Skeleton className="h-8 w-48 rounded-[var(--radius-md)]" />
      {[0, 1, 2].map((i) => (
        <div key={i} className="card surface-enter space-y-3">
          <Skeleton className="h-5 w-64 rounded-[var(--radius)]" />
          <div className="space-y-2 pl-4">
            {[0, 1].map((j) => (
              <Skeleton key={j} className="h-4 w-full rounded-[var(--radius)]" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
